import request from '@a/js/request'

// 获取门票列表
export function GetTicketList(query, lang) {
  return request({
    url: '/c/ticket/v1/ticket' + `?lang=${lang ? lang : 'zh'}`,
    method: 'get',
    params: query,
  })
}

// 获取表单配置
export function GetFormOption(query, lang) {
  return request({
    url: '/c/ticket/v1/form' + `?lang=${lang ? lang : 'zh'}`,
    method: 'get',
    params: query,
  })
}
// 获取协议详情
export function GetProtocolInfo(query, lang) {
  return request({
    url: '/c/ticket/v1/protocol' + `?lang=${lang ? lang : 'zh'}`,
    method: 'get',
    params: query,
  })
}
